"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFirstProcessedPaymentWithoutBankMockData = exports.buildBankAccountUpdateMockData = void 0;
const organization_facing_base_1 = require("./organization-facing-base");
const buildBankAccountUpdateMockData = ({ locale = "en", subject = "Your bank account has been updated", firstName = "John", organizationName = "Bright Futures Foundation", bankName = "Test Bank", lastDigits = "4321", routingNumber = "123456789", pausePayoutLink = "https://www.zeffy.com/pause-payout?token=mock-token", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    organizationName,
    bankName,
    lastDigits,
    routingNumber,
    pausePayoutLink,
});
exports.buildBankAccountUpdateMockData = buildBankAccountUpdateMockData;
const buildFirstProcessedPaymentWithoutBankMockData = ({ locale = "en", subject = "Connect your bank account to receive your payouts", firstName = "John", orgName = "Bright Futures Foundation", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    orgName,
});
exports.buildFirstProcessedPaymentWithoutBankMockData = buildFirstProcessedPaymentWithoutBankMockData;
